import { render, staticRenderFns } from "./user_informations.vue?vue&type=template&id=72904060&scoped=true&"
import script from "./user_informations.vue?vue&type=script&lang=js&"
export * from "./user_informations.vue?vue&type=script&lang=js&"
import style0 from "./user_informations.vue?vue&type=style&index=0&id=72904060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72904060",
  null
  
)

export default component.exports